import isMobileFn from "is-mobile";
export const isMobile = isMobileFn({ tablet: true, featureDetect: true });
